import React from "react";

const AvailableLocations = () => {

    return (

        // <div className="tab-content dc-contentdoctab dc-haslayout">
        //     <div className="dc-location-holder tab-pane fade active show" id="locations">
        //         <div className="dc-searchresult-holder">
        //             <div className="dc-searchresult-head">
        //                 <div className="dc-title"><h4>“Flores Emily” Locations</h4></div>
        //             </div>
        //             <div className="dc-searchresult-grid dc-searchresult-list dc-searchvlistvtwo">
        //             </div>
        //         </div>
        //     </div>

        //     <div className="dc-shareprofile">
        //         <ul className="d-flex dc-tags-social">
        //             <li className="dc-sharejob">Share Profile:</li>
        //             <li className="dc-fb">
        //                 <a href="//www.facebook.com/sharer.php?u=https%3A%2F%2Fmeddylist.com%2Fdoctors%2Fflores-emily%2F" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
        //                     <i className="fab fa-facebook-f"></i>
        //                 </a>
        //             </li>
        //             <li className="dc-twit">
        //                 <a href="//twitter.com/intent/tweet?text=Flores+Emily&amp;url=https%3A%2F%2Fmeddylist.com%2Fdoctors%2Fflores-emily%2F&amp;via=envato">
        //                     <i className="fab fa-twitter"></i>
        //                 </a>
        //             </li>
        //             <li className="dc-google-plus">
        //                 <a href="//plus.google.com/share?url=//css.meddylist.com//doctors/flores-emily/" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
        //                     <i className="fab fa-google-plus-g"></i>
        //                 </a>
        //             </li>
        //             <li className="dc-instg">
        //                 <a href="//pinterest.com/pin/create/button/?url=//css.meddylist.com//doctors/flores-emily/&amp;media=//css.meddylist.com//wp-content/uploads/2019/09/asian-male-doctor-man-indian-wea-308x220.png&amp;description=Flores+Emily" onclick="window.open(this.href, 'post-share','left=50,top=50,width=600,height=350,toolbar=0'); return false;">
        //                     <i className="fab fa-pinterest-p"></i>
        //                 </a>
        //             </li>
        //         </ul>
        //     </div>
        // </div>
        <></>
    );
};

export default AvailableLocations;
